// The .pswp root and the lazy-loaded library are global already, but the wrapper
// driving them is private to the theme bundle.
(() => {
  const TRIGGER_SELECTOR = '[data-cart-zoom]';

  let libraryPromise = null;

  function loadLibrary() {
    if (window.themePhotoswipe) return Promise.resolve();
    if (libraryPromise) return libraryPromise;

    const src = window.theme && window.theme.assets && window.theme.assets.photoswipe;
    if (!src) return Promise.reject(new Error('photoswipe asset url missing'));

    libraryPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = src;
      script.onload = resolve;
      script.onerror = () => reject(new Error('photoswipe failed to load'));
      document.head.appendChild(script);
    });
    return libraryPromise;
  }

  /**
   * Calculate the real size of the image for the zoom, falling back to the trigger's data attributes if necessary.
   * - The zoom width and height are set as data attributes but hard-coded (not read from the image) because the image is
   *   an uploaded file rather than something we can get from the `images` liquid object.
   * - If the image is loaded, return the natural width and height
   * - Otherwise, load the image to determine its natural width and height
   * @param {Element} trigger 
   * @returns {Promise<{w: number, h: number}>} The width and height of the image.
   */
  function imageSize(trigger) {
    const fallback = {
      w: parseInt(trigger.dataset.cartZoomWidth, 10),
      h: parseInt(trigger.dataset.cartZoomHeight, 10),
    };
    const thumb = trigger.querySelector('img');
    if (thumb && thumb.complete && thumb.naturalWidth) {
      return Promise.resolve({ w: thumb.naturalWidth, h: thumb.naturalHeight });
    }

    return new Promise((resolve) => {
      const image = new Image();
      image.onload = () => resolve(image.naturalWidth ? { w: image.naturalWidth, h: image.naturalHeight } : fallback);
      image.onerror = () => resolve(fallback);
      image.src = trigger.dataset.cartZoom;
    });
  }

  function open(trigger, size) {
    const root = document.querySelector('.pswp');
    if (!root) return;

    const item = {
      src: trigger.dataset.cartZoom,
      w: size.w,
      h: size.h,
    };
    if (!item.src || !item.w || !item.h) return;

    root.classList.remove('pswp--custom-loader');

    const PhotoSwipe = window.themePhotoswipe.PhotoSwipe.default;
    const PhotoSwipeUI = window.themePhotoswipe.PhotoSwipeUI.default;

    new PhotoSwipe(root, PhotoSwipeUI, [item], {
      history: false,
      focus: false,
      mainClass: 'pswp--cart-zoom',
      showHideOpacity: true,
      closeOnScroll: false,
      closeOnVerticalDrag: true,
      captionEl: false,
      shareEl: false,
      counterEl: false,
      maxSpreadZoom: 2,
      getThumbBoundsFn: () => {
        const rect = trigger.getBoundingClientRect();
        return { x: rect.left, y: rect.top + (window.scrollY || document.documentElement.scrollTop), w: rect.width };
      },
    }).init();
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(TRIGGER_SELECTOR);
    if (!trigger) return;
    event.preventDefault();
    Promise.all([loadLibrary(), imageSize(trigger)]).then(([, size]) => open(trigger, size)).catch(() => {});
  });
})();
